import React from 'react'
import styled from 'styled-components'
import { media } from 'styled-bootstrap-grid'
import theme from 'ui/styles/theme'

const Wrapper = styled.div`
  height: ${props => props.distance * 50}px;
  background-color: ${props => props.bgcolor === 'white' ? 'white' : theme.colors.tones.lightest};

  ${media.xs`
    height: ${props => props.distance * 20}px;
  `}
`

export default ({ distance, bgcolor }) => (<Wrapper distance={distance} bgcolor={bgcolor} />)



// WEBPACK FOOTER //
// ./src/ui/components/modules/Distance/index.js